var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "stats-mpa-legend" }, [
      _c("table", [
        _c("tr", [
          _c("td", [
            _c("div", {
              staticStyle: { "background-color": "rgba(124, 184, 84, 1)" },
            }),
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "Area in an MPA and protected by a byelaw restricting bottom towed fishing gear"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [
            _c("div", {
              staticStyle: { "background-color": "rgba(242, 183, 1, 1)" },
            }),
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "Area in an MPA but not protected by a byelaw restricting bottom towed fishing gear"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [
            _c("div", {
              staticStyle: { "background-color": "rgba(48, 93, 158, 1)" },
            }),
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "Area not in an MPA but protected by a byelaw restricting bottom towed fishing gear"
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", [
            _c("div", {
              staticStyle: { "background-color": "rgba(194, 195, 196, 1)" },
            }),
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              "Area not in an MPA or protected by a byelaw restricting bottom towed fishing gear"
            ),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }